/**
 * useCanManageFloor: may the caller make the floor owner's calls on the
 * selected floor (print technology switch, BLU-1412; client QC redo,
 * BLU-1462)?
 *
 * True only with `production_settings.manage` on a floor the active org owns.
 * A client org viewing a 3PL floor gets false (the server's owner-floor fence
 * refuses it anyway). Call it once in the parent and pass the result down as
 * `canManageFloor`, not once per garment table.
 */
import { useLocation } from '@/contexts/LocationContext';
import { useOrganization } from '@/contexts/OrganizationContext';
import { useRole } from '@/hooks/use-role';
import { isOwnedFloor } from '@/features/inventory/hooks/useOwnedFloorIds';

export function useCanManageFloor(): boolean {
  const { can } = useRole();
  const { selectedLocation } = useLocation();
  const { organization } = useOrganization();
  return (
    can('production_settings.manage') && !!selectedLocation && isOwnedFloor(selectedLocation, organization?.id)
  );
}
